/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Save_To_Space_FileInputs */



/**
* | output |
* | --- |
* | "File: {name}" |
*
* @param {Chat_Save_To_Space_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_file = /** @type {((inputs: Chat_Save_To_Space_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_FileInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Datei: ${i?.name}`)
	return /** @type {LocalizedString} */ (`File: ${i?.name}`)
});